import {
  BillingProduct,
  HubContentCustomField,
  Image,
} from '@tribeplatform/gql-client/types'

const getFieldByKey = (fields: HubContentCustomField[], key: string) => {
  try {
    const field = fields.find(field => field.key === key)
    const value = field?.value ? (JSON.parse(field.value) as string) : null
    const medias = field?.relationEntities?.medias as Image[]

    return {
      value,
      medias,
    }
  } catch (e) {
    return null
  }
}

export const getAddonFields = (addon?: BillingProduct) => {
  const content = getFieldByKey(addon?.hubContent?.fields, 'content')?.value
  const [banner] =
    getFieldByKey(addon?.hubContent?.fields, 'banner')?.medias ?? []

  const features =
    getFieldByKey(addon?.hubContent?.fields, 'feature_items')
      ?.value?.split('\n')
      .map(it => it.trim())
      .filter(Boolean) ?? addon?.features

  const title =
    getFieldByKey(addon?.hubContent?.fields, 'title')?.value ?? addon?.name
  const description =
    getFieldByKey(addon?.hubContent?.fields, 'description')?.value ??
    addon?.description

  return {
    content,
    banner,
    features,
    title,
    description,
  }
}
